module.exports = __webpack_public_path__ + "img/point.96c2c2f1.png";